export * from './auth';
export * from './cust';

/**
 * APIパス
 */
export const pathnames = {
  login: '/api/auth/login',
  logout: '/api/auth/logout',
  contact: '/api/cust/contact',
  customers: '/api/cust/customers',
  equipments: '/api/cust/equipments',

  manual: '/api/pdf/manual',

  equipment: '/api/equipment/list',
  equipmentCount: '/api/equipment/count',
  oneEquipment: '/api/equipment/one',

  deviceList: '/api/device/list',
  deviceCount: '/api/device/count',
  deviceDetail: '/api/device/detail',

  partslist: '/api/parts/list',
  countparts: '/api/parts/count',
  partsdetail: '/api/parts/Detail',

  deviceItemList: '/api/deviceitem/list',
  deviceItemCount: '/api/deviceitem/count',
  deviceMaintList: '/api/devicemaint/list',
  deviceMaintCount: '/api/devicemaint/count',
  deviceMaintDetail: '/api/devicemaint/detail',
  deviceTroubleList: '/api/devicetrouble/list',
  deviceTroubleCount: '/api/devicetrouble/count',
  deviceTroubleDetail: '/api/devicetrouble/detail',

  eqHisList: '/api/eqhis/list',
  eqHisCount: '/api/eqhis/count',
  eqHisDetail: '/api/eqhis/detail',
  eqMaintList: '/api/eqmaint/list',
  eqMaintCount: '/api/eqmaint/count',
  eqTroubleList: '/api/eqtrouble/list',
  eqTroubleCount: '/api/eqtrouble/count',
  eqTroubleDetail: '/api/eqtrouble/detail',
  eqCsetList: '/api/eqcset/list',
  eqCsetCount: '/api/eqcset/count',
  eqCsetDetail: '/api/eqcset/detail',
} as const;
